import React from 'react';

interface DesignIconProps {
  className?: string;
}

const DesignIcon: React.FC<DesignIconProps> = ({ className = "h-4 w-4" }) => {
  return (
    <svg 
      className={className}
      viewBox="0 0 48 48" 
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M36.75,31.36707V19c0-0.96497-0.37164-1.87524-1.01727-2.56354c2.8902-3.22302,3.70337-5.40643,2.4743-6.64984
        c-1.42969-1.41553-4.12207-0.11133-8.22949,3.98438c-0.49054,0.49341-0.96301,0.98822-1.41357,1.479H15
        c-2.06738,0-3.75,1.68213-3.75,3.75v12.36707c-1.15063,0.32886-2,1.37805-2,2.63293c0,2.61914,2.13086,4.75,4.75,4.75h20
        c2.61914,0,4.75-2.13086,4.75-4.75C38.75,32.74512,37.90063,31.69592,36.75,31.36707z M31.03906,14.83105
        c3.98926-3.979,5.74023-4.34424,6.10742-3.98389c0.36523,0.36914,0.00293,2.12207-3.97559,6.11133
        c-0.44232,0.44-0.88483,0.86133-1.32397,1.2674l-2.07294-2.07257C30.17938,15.71466,30.59991,15.27271,31.03906,14.83105z
         M26.91992,21.08008c0.73145,0.73096,0.77051,1.88086,0.08887,2.56348c-1.06738,1.06738-2.87109,1.17236-3.80859,1.15137
        c-0.02539-1.0542,0.1543-2.80127,1.15625-3.80322C25.04004,20.30908,26.18945,20.34961,26.91992,21.08008z M28.60968,20.90942
        c-0.16168-0.3183-0.36212-0.62292-0.62921-0.88989c-0.26666-0.26697-0.57104-0.46741-0.88916-0.62909
        c0.48639-0.66913,1.04871-1.37598,1.68518-2.11359l1.94708,1.94678C29.98596,19.86041,29.27899,20.42291,28.60968,20.90942z
         M15,16.75h12.24817c-0.66711,0.7959-1.24066,1.55365-1.7301,2.26465c-0.81268,0.00983-1.6134,0.30847-2.22217,0.9165
        c-2.00684,2.00732-1.55859,5.52002-1.53809,5.66846c0.04491,0.33392,0.30849,0.59756,0.64239,0.64255
        c1.91505,0.25808,4.2594-0.12677,5.66913-1.53806c0.60742-0.60809,0.90601-1.40857,0.91589-2.22137
        c1.57617-1.08545,3.41589-2.64246,5.24622-4.46271c0.16382-0.16431,0.31561-0.32245,0.47052-0.48224
        C35.04834,17.94141,35.25,18.45502,35.25,19v12.25h-5.13184c-0.97559,0-1.85254,0.54199-2.28906,1.41504
        C27.64844,33.02539,27.28516,33.25,26.88184,33.25h-5.76367c-0.40332,0-0.7666-0.22461-0.94727-0.58496
        C19.73438,31.79199,18.85742,31.25,17.88184,31.25H12.75V19C12.75,17.75928,13.75977,16.75,15,16.75z M34,37.25H14
        c-1.79199,0-3.25-1.45801-3.25-3.25c0-0.68945,0.56055-1.25,1.25-1.25h5.88184c0.40332,0,0.7666,0.22461,0.94727,0.58496
        c0.43652,0.87305,1.31348,1.41504,2.28906,1.41504h5.76367c0.97559,0,1.85254-0.54199,2.28906-1.41504
        c0.18066-0.36035,0.54395-0.58496,0.94727-0.58496H36c0.68945,0,1.25,0.56055,1.25,1.25C37.25,35.79199,35.79199,37.25,34,37.25z"/>
    </svg>
  );
};

export default DesignIcon;
